import { render, staticRenderFns } from "./ProductFamilyAttaches.vue?vue&type=template&id=8b571896&scoped=true&"
import script from "./ProductFamilyAttaches.vue?vue&type=script&lang=js&"
export * from "./ProductFamilyAttaches.vue?vue&type=script&lang=js&"
import style0 from "./ProductFamilyAttaches.vue?vue&type=style&index=0&id=8b571896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b571896",
  null
  
)

export default component.exports